import { render } from "./NotShippableCell.vue?vue&type=template&id=6991b404"
import script from "./NotShippableCell.vue?vue&type=script&lang=js"
export * from "./NotShippableCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__